var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full mobile:p-4 tablet:p-6",
      attrs: { "data-test": "tab-shownotes" }
    },
    [
      _c(
        "tab-title",
        { attrs: { tab: "shownotes" }, on: { close: _vm.closeTab } },
        [_vm._v(_vm._s(_vm.$t("SHOWNOTES.TITLE")))]
      ),
      _c("h4", { staticClass: "text-sm font-bold" }, [
        _vm._v(_vm._s(_vm.showTitle))
      ]),
      _c("h3", { staticClass: "text-lg font-bold mb-4" }, [
        _vm._v(_vm._s(_vm.episodeTitle))
      ]),
      _c("p", { staticClass: "text-base font-semibold mb-3" }, [
        _vm._v(_vm._s(_vm.subtitle))
      ]),
      _c("p", {
        staticClass: "mb-3",
        domProps: { innerHTML: _vm._s(_vm.summary) }
      }),
      _c("divider", { staticClass: "mb-4" }),
      _vm._l(_vm.groups, function(group, gid) {
        return _c("div", { key: "group-" + gid }, [
          _c("h3", { staticClass: "text-sm font-bold mb-4" }, [
            _vm._v(_vm._s(group.title))
          ]),
          _c(
            "div",
            { staticClass: "flex flex-wrap" },
            _vm._l(group.contributors, function(contributor, cid) {
              return _c(
                "div",
                {
                  key: "group-" + gid + "-contributor-" + cid,
                  staticClass: "flex items-center mr-16 last:mr-0 mb-4"
                },
                [
                  _c("img", {
                    staticClass: "rounded-full h-16",
                    attrs: { src: contributor.avatar }
                  }),
                  _c(
                    "span",
                    { staticClass: "text-base font-semibold pr-4 pl-4" },
                    [_vm._v(_vm._s(contributor.name))]
                  )
                ]
              )
            }),
            0
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }